import { cssMemberListItem, cssMemberText } from "app/client/ui/UserItem";
import { theme } from "app/client/ui2018/cssVars";
import { unstyledButton } from "app/client/ui2018/unstyled";
import { tokens } from "app/common/ThemePrefs";

import { styled } from "grainjs";

// Small form kit shared between the OAuth-app settings page and the consent page.
export const cssFormGroup = styled("div", `
  display: flex;
  flex-direction: column;
  margin: 16px 0;
`);

export const cssFormLabel = styled("label", `
  display: block;
  margin: 8px 0;
  font-size: ${tokens.mediumFontSize};
  font-weight: ${tokens.headerControlTextWeight};
  color: ${theme.text};
`);

export const cssFormLabelHint = styled("span", `
  font-weight: normal;
  color: ${theme.lightText};
  &::before {
    content: " — ";
  }
`);

export const selectAccountForms = styled("div", `
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-bottom: 24px;
  width: 100%;
`);

export const selectAccountForm = styled("form", `
  max-width: 400px;
  width: 100%;
`);

export const accountButtons = styled("div", `
  display: flex;
  flex-direction: column;
  position: relative;
`);

export const accountButton = styled(unstyledButton, `
  border-radius: 16px;
  cursor: pointer;
  transition: background-color 0.2s linear;

  &:focus {
    outline: none;
  }

  &:hover, &:focus {
    background-color: ${tokens.bgTertiary};
  }

  &:not(&-add)::after {
    border-bottom: 1px solid ${tokens.decoration};
    content: "";
    height: 0;
    left: 16px;
    position: absolute;
    width: calc(100% - 32px);
  }
`);

export const account = styled(cssMemberListItem, `
  align-items: center;
  gap: 16px;
  margin: 0;
  min-height: unset;
  padding: 16px;
  width: 100%;
`);

export const accountSmall = styled(account, `
  padding: 4px;
`);

export const accountNameAndEmail = styled(cssMemberText, `
  align-items: flex-start;
  margin: 0;
`);

export const changeAccountButton = styled(unstyledButton, `
  border: 1px solid ${tokens.decoration};
  border-radius: 16px;
  cursor: pointer;
  display: block;

  &:hover, &:focus {
    background-color: ${tokens.bgTertiary};
  }
`);
